import { motion } from "framer-motion";
import React from "react";
import { Wifi, Utensils, Car, Tv, Thermometer, Briefcase, Wind, Waves } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AccommodationDetail() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const features = [{
    icon: Wifi,
    label: "High-Speed WLAN"
  }, {
    icon: Utensils,
    label: "Kaffee-Flatrate"
  }, {
    icon: Car,
    label: "Kostenloses Parken"
  }, {
    icon: Tv,
    label: "Präsentations-TV"
  }, {
    icon: Thermometer,
    label: "Klimatisierung"
  }, {
    icon: Briefcase,
    label: "Ergo-Arbeitsplatz"
  }];
  return <section data-section-id="12953" id="ausstattung" ref={ref} className="bg-[#EEEEEE] ![padding:144px_0px_144px_0px]">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-stretch">
      {/* Left: Text (no box) */}
      <motion.div initial={{
          opacity: 0,
          y: 12
        }} animate={isVisible ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 12
        }} transition={{
          duration: 0.7,
          ease: "easeOut"
        }} className="flex flex-col justify-between py-4">
        <div>
          <span className="text-sm font-semibold uppercase tracking-widest text-[#888888] mb-4 block">Ausstattung</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-6">
            <span className="text-[#141414]">Alles da.</span><br />
            <span className="text-[#888888]">Alles durchdacht.</span>
          </h2>
        </div>
        <div className="mt-auto pt-20">
          <div className="flex flex-wrap gap-2 mb-8">
            <span className="inline-block rounded-full bg-[#141414]/5 border border-[#141414]/10 px-4 py-2 text-sm font-medium text-[#555555]">Infrastruktur</span>
            <span className="inline-block rounded-full bg-[#141414]/5 border border-[#141414]/10 px-4 py-2 text-sm font-medium text-[#555555]">Vernetzen</span>
          </div>
          <p className="text-base text-[#555555] leading-relaxed">
            Ein guter Arbeitsplatz ist mehr als ein Schreibtisch. Es ist das Gefühl, anzukommen und loslegen zu können. Genau das haben wir gebaut.
          </p>
        </div>
      </motion.div>
      {/* Right: Dark Card */}
      <motion.div initial={{
          opacity: 0,
          y: 12
        }} animate={isVisible ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 12
        }} transition={{
          duration: 0.7,
          ease: "easeOut",
          delay: 0.2
        }} className="rounded-[1rem] bg-[#141414] p-8 sm:p-12 md:p-16 flex flex-col justify-between min-h-[600px]">
        <div>
          <h3 className="text-2xl md:text-3xl font-bold text-white tracking-tight mb-4">
            Ausstattung, die den Unterschied macht.
          </h3>
          <p className="text-base text-white/60 leading-relaxed mb-10">
            Jedes Detail ist darauf ausgelegt, dich produktiver zu machen und Ablenkungen leise in den Hintergrund treten zu lassen.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-4 sm:gap-4">
          {features.map((feature, i) => <motion.div key={i} data-index={i} initial={{
              opacity: 0,
              y: 8
            }} animate={isVisible ? {
              opacity: 1,
              y: 0
            } : {
              opacity: 0,
              y: 8
            }} transition={{
              duration: 0.5,
              ease: "easeOut",
              delay: 0.4 + i * 0.1
            }} className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 group">
              <div className="flex-shrink-0 flex h-10 w-10 items-center justify-center rounded-xl bg-white/10 transition-colors duration-300 group-hover:bg-[#FF6F61]/20">
                <feature.icon className="size-5 text-[#FF6F61]" />
              </div>
              <span className="text-xs sm:text-sm font-medium text-white/80">{feature.label}</span>
            </motion.div>)}
        </div>
      </motion.div>
    </div>
  </div>
</section>;
}